"use strict";

var _classCallCheck = require("/Users/tapanshah/aenetworks/aetn.editorials.washington/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/tapanshah/aenetworks/aetn.editorials.washington/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/tapanshah/aenetworks/aetn.editorials.washington/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/tapanshah/aenetworks/aetn.editorials.washington/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/tapanshah/aenetworks/aetn.editorials.washington/node_modules/@babel/runtime/helpers/inherits");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = exports.Footer = exports.socialUrlMap = void 0;

var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _reactJss = require("react-jss");

var _format = _interopRequireDefault(require("date-fns/format"));

var _Typography = _interopRequireDefault(require("@aetn/ui-core/Typography"));

var _LinkList = _interopRequireDefault(require("./LinkList"));

var _Title = _interopRequireDefault(require("./Title"));

var _FollowButton = _interopRequireDefault(require("./FollowButton"));

var _Footer = _interopRequireDefault(require("./Footer.styles"));

var _class;

function _getRequireWildcardCache() {
  if (typeof _WeakMap !== "function") return null;
  var cache = new _WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        _Object$defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = _assign["default"] || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var socialUrlMap = {
  facebook: {
    url: 'https://www.facebook.com/',
    icon: 'social-facebook'
  },
  twitter: {
    url: 'https://twitter.com/',
    icon: 'social-twitter'
  },
  instagram: {
    url: 'https://www.instagram.com/',
    icon: 'social-instagram'
  },
  pinterest: {
    url: 'https://www.pinterest.com/',
    icon: 'social-pinterest'
  },
  youtube: {
    url: 'https://www.youtube.com/',
    icon: 'youtube-dark'
  },
  tumblr: {
    url: 'https://www.tumblr.com/',
    icon: 'social-tumblr'
  },
  spotify: {
    url: 'https://open.spotify.com/',
    icon: 'spotify-dark'
  }
};
exports.socialUrlMap = socialUrlMap;
var currentYear = (0, _format["default"])(new Date(), 'YYYY');

var Footer = (0, _Footer["default"])(_class = (0, _reactJss.withTheme)(_class =
/*#__PURE__*/
function (_react$Component) {
  _inherits(Footer, _react$Component);

  function Footer() {
    _classCallCheck(this, Footer);

    return _possibleConstructorReturn(this, _getPrototypeOf(Footer).apply(this, arguments));
  }

  _createClass(Footer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          brand = _this$props.brand,
          brandName = _this$props.brandName,
          origin = _this$props.origin,
          menu = _this$props.menu,
          socialLabel = _this$props.socialLabel,
          socials = _this$props.socials,
          noBrandMenu = _this$props.noBrandMenu;
      return _react["default"].createElement("footer", {
        className: classes.root
      }, _react["default"].createElement("div", {
        className: classes.sections
      }, _react["default"].createElement(_Title["default"], {
        link: "https://www.aenetworks.com/",
        title: "A+E Networks",
        description: "Our Family of Brands"
      }), !noBrandMenu && _react["default"].createElement("div", {
        className: "".concat(classes.section, " ").concat(classes.sectionGrow)
      }, _react["default"].createElement("div", {
        className: classes.sectionInner
      }, _react["default"].createElement("a", {
        href: origin,
        className: classes.logo,
        "aria-label": "".concat(brandName, " homepage")
      }), _react["default"].createElement(_LinkList["default"], {
        items: menu
      }), _react["default"].createElement(_Typography["default"], {
        className: classes.followHead,
        type: "text",
        tag: "strong"
      }, "Follow ".concat(socialLabel || brandName)), _react["default"].createElement(_LinkList["default"], {
        className: "".concat(classes.iconLinks, " ").concat(classes.social),
        items: socials,
        renderLink: function renderLink(type, item) {
          return _react["default"].createElement(_FollowButton["default"], _extends({
            className: classes.socialIcon,
            type: type,
            socialMap: socialUrlMap
          }, item));
        }
      }))), _react["default"].createElement("div", {
        className: "".concat(classes.section, " ").concat(classes.sectionFixed)
      }, _react["default"].createElement("div", {
        className: classes.sectionInner
      }, _react["default"].createElement(_LinkList["default"], {
        className: "".concat(classes.iconLinks, " ").concat(classes.channels),
        items: {
          'AETV homepage': {
            href: 'https://www.aetv.com',
            className: classes.aetv,
            hidden: brand === 'aetv'
          },
          'HISTORY homepage': {
            href: 'https://www.history.com',
            className: classes.history,
            hidden: brand === 'history' || brand === 'historyvault'
          },
          'MYLIFETIME homepage': {
            href: 'https://www.mylifetime.com',
            className: classes.lifetime,
            hidden: brand === 'lifetime' || brand === 'lmc'
          },
          'MYLIFETIME movies homepage': {
            href: 'https://www.mylifetime.com/lifetime-movies',
            className: classes.lmn,
            hidden: brand === 'lmn'
          },
          'FYI homepage': {
            href: 'https://www.fyi.tv',
            className: classes.fyi,
            hidden: brand === 'fyi'
          },
          'VICELAND homepage': {
            href: 'https://viceland.com/en_us/',
            className: classes.viceland,
            hidden: brand === 'viceland'
          }
        },
        renderLink: function renderLink(label, props) {
          return _react["default"].createElement("a", _extends({}, props, {
            "aria-label": label
          }));
        }
      }), _react["default"].createElement("div", {
        className: "".concat(classes.textLinks, " ").concat(classes.links)
      }, _react["default"].createElement(_LinkList["default"], {
        items: {
          Biography: 'https://www.biography.com/',
          'Crime and Investigation': 'https://www.crimeandinvestigationnetwork.com/'
        }
      }), _react["default"].createElement(_LinkList["default"], {
        items: {
          'History en Espanol': 'https://www.historyenespanol.com/',
          LRW: 'https://www.mylifetime.com/schedule/lrw'
        }
      }), _react["default"].createElement(_LinkList["default"], {
        items: {
          'Military History': 'https://military.history.com/'
        }
      }))), _react["default"].createElement("div", {
        className: classes.sectionInner
      }, _react["default"].createElement("div", {
        className: "".concat(classes.textLinks, " ").concat(classes.links)
      }, _react["default"].createElement(_LinkList["default"], {
        items: {
          'Ad Choices': 'https://www.aenetworks.com/adchoices',
          'Advertise WIth Us': 'https://www.aenetworks.com/advertise',
          'Accessibility Support': 'https://www.aenetworks.com/accessibility-support',
          'Copyright Policy': 'https://www.aenetworks.com/copyright'
        }
      }), _react["default"].createElement(_LinkList["default"], {
        items: {
          'Corporate Information': 'https://www.aenetworks.com/',
          'Employment Opportunities': 'https://www.aenetworks.com/careers',
          'FAQ/Contact Us': 'https://history.zendesk.com/hc/en-us',
          'Privacy Notice': 'https://www.aenetworks.com/privacy'
        }
      }), _react["default"].createElement(_LinkList["default"], {
        items: {
          'Cookie Notice': 'https://www.aenetworks.com/cookie-notice',
          'Terms Of Use': 'https://www.aenetworks.com/terms',
          'TV Parental Guidelines': 'https://www.aenetworks.com/guidelines',
          'Do Not Sell My Personal Information': 'https://forms.dsr-communications.com/custom/70328B73-2FB9-4426-9342-1C0D06F2EBC9'
        }
      }))))), _react["default"].createElement("div", {
        className: classes.bottomstrip
      }, _react["default"].createElement(_LinkList["default"], {
        className: "".concat(classes.iconLinks, " ").concat(classes.channels),
        items: {
          'Contact Us': 'https://www.aenetworks.com/contact',
          'Copyright Policy': 'https://www.aenetworks.com/copyright',
          'Privacy Policy': 'https://www.aenetworks.com/privacy',
          'Terms of Use': 'https://www.aenetworks.com/terms',
          'Ad Choices': 'https://www.aenetworks.com/adchoices',
          'Accessibility Support': 'https://www.aenetworks.com/accessibility-support'
        },
        renderLink: function renderLink(title, href) {
          return _react["default"].createElement(_Typography["default"], {
            type: "textSm",
            tag: "a",
            href: href,
            target: "_blank"
          }, title);
        }
      }), _react["default"].createElement(_Typography["default"], null, "\xA9 ", currentYear, ", A&E Television Networks, LLC. All Rights Reserved.")));
    }
  }]);

  return Footer;
}(_react.Component)) || _class) || _class;

exports.Footer = Footer;
var _default = Footer;
exports["default"] = _default;
Footer.propTypes = {
  brand: _propTypes.string.isRequired,
  brandName: _propTypes.string.isRequired,
  socialLabel: _propTypes.string.isRequired,
  origin: _propTypes.string.isRequired,
  menu: _propTypes.object.isRequired,
  socials: _propTypes.object.isRequired,
  noBrandMenu: _propTypes.bool
};